import { useEffect, useState } from 'react';
import { useGetAllBillingDetailsQuery } from '../../../../store/services/admin/UserService';
import { Table } from '../../../components/Sessions/Table';
import Pagination from '../../../components/Dashboard/Pagination';

const TransactionsTable = () => {
    const [sessionsData, setSessionsData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize] = useState(10);

    const columns = [
        { header: "Transaction ID", accessor: "billingId",
          render: (billing) => (
                <span className="text-primary font-monospace small">
                    {billing.billingId}
                </span>
        )},
        { header: 'Date', accessor: 'billingDate',
            render: (billing) => new Date(billing.billingDate).toLocaleDateString()
        },
        { header: 'Tutor', accessor: 'tutorName' },
        { header: 'Student', accessor: 'studentName' },
        { header: 'Language', accessor: 'sessionTitle' },
        { header: 'Amount($)', accessor: 'amount' },
        { header: 'Payment Status', accessor: 'paymentStatus',
            render: (item) => (
                <span className={`font-w600 text-success`}>{item.paymentStatus}</span>
            ),
        },
        { header: 'Payment Method', accessor: 'paymentMethod' },
    ]

    const { data, isLoading, error } = useGetAllBillingDetailsQuery(
        { pageNumber: currentPage, pageSize: pageSize, search: searchTerm});
    
    useEffect(() => {
        if (data?.data) {
          setSessionsData(data.data.items || []);
          setTotalCount(data.data.totalCount || 0);
        }
    }, [data]);

    
    if (isLoading) return <div className="text-center py-5"><div className="spinner-border" role="status"></div></div>;
    if (error) return <div className="alert alert-danger">Error loading billing details.</div>;
    
    return (
        <div className="bg-white">
          <div className="page-title flex-wrap mb-0">
            <div className="input-group search-area mb-md-0 ml-3">
              <input
                type="text"
                className="form-control ps-4"
                placeholder="Search here..."
                value={searchTerm}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchTerm(e.target.value);
                }}
              />
            </div>

          </div>
    
          <Table
            data={sessionsData}
            columns={columns}
            pageSize={pageSize}
            filterConfig={[]}
            buttonConfig={[]}
            searchableColumns={[]}
          />
    
          <Pagination currentPage={currentPage} totalCount={totalCount}
                pageSize={pageSize} onPageChange={setCurrentPage} />
        </div>
    );
};

export default TransactionsTable;